// extracted by mini-css-extract-plugin
export var blushIllustration = "br_fc";
export var button = "br_cc";
export var cardHeadline = "br_fb";
export var cardRoot = "br_d9";
export var cardSubtitle = "br_ff";
export var rowTwo = "br_fd";
export var wrapper = "br_b9";